export enum TuffexProductCollectionWorkspaceCapabilityAccessOperation {
    create = "064e92cb-cc63-4adb-8368-0fc3f4328446",
    read = "273ef00d-b59c-4950-a989-2495e79555fc",
    update = "e3c14c90-a91e-4c7a-845e-93b61a628072",
    delete = "f3828edd-2273-4594-ba2f-4e73cf13559e",
}
